import React from 'react';
import { useSelector } from 'react-redux';
import { ThreeLeadPlotContainer } from '../../plot/components/ThreeLeadPlotContainer';
import { useQRSListener } from '../hooks/useQRSListener';
import { ecgIdSelector } from '../selectors/ecg.selectors';
import { ILRImagePlot } from './ILRImagePlot';

export const ILRPlot: React.FC = () => {
  useQRSListener();
  const ecgId = useSelector(ecgIdSelector);

  if (!ecgId) {
    return null;
  }

  return (
    <>
      <ILRImagePlot ecgId={ecgId} />
      <ThreeLeadPlotContainer />
    </>
  );
};
